export class MaintenanceStrategyModel {
  maintenanceStrategyId: number = 0;
  companyId: number = 0;
  articleId: number = 0;
  interval: number = 0;
  maintenancePlan: number = 0;
  createDate: string = "";
  userNameCreate: string = "";
  updateDate: string | null = null;
  userNameUpdate: string | null = null;
}